import Box from "@mui/material/Box";
import { Seo } from "~/components/seo";
import { Layout as DashboardLayout } from "~/layouts/dashboard";
import { CreateFileModal, ViewFileModal } from "~/sections/file/file-modal";
import { TillModal } from "~/sections/file/till-modal";
import { useAppRouter } from "~/hooks/use-app-router";
import { useTillIsOpen } from "~/store";
import type { NextPage } from "next";
import { Files } from "~/sections/file";
import { ViewPreference } from "~/layouts/dashboard/view-preference";
import { MultiSelectButton } from "~/layouts/dashboard/multi-select-button";
import { SearchButton } from "~/layouts/dashboard/search-button";
import { ProcessFilter } from "~/layouts/dashboard/process-filter";
import { usePermissionFilters } from "~/hooks/use-permission-filters";
const Page: NextPage = () => {
  const {
    currentActions: {
      isViewingFile,
      isCreatingFile
    }
  } = useAppRouter();
  const isOpen = useTillIsOpen();
  return <>
			<Seo data-sentry-element="Seo" data-sentry-source-file="index.tsx" />

			{isCreatingFile && <CreateFileModal />}
			{isViewingFile && <ViewFileModal />}
			{isOpen && <TillModal />}

			<Box component="main" sx={{
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      overflow: "hidden",
      pt: 2
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
				<Files data-sentry-element="Files" data-sentry-source-file="index.tsx" />
			</Box>
		</>;
};
const NavItems = () => {
  const permissions = usePermissionFilters();
  return <>
			{permissions.CREATE_MONTHLY_STATEMENT ? <MultiSelectButton monthlyStatement moveProcess /> : <MultiSelectButton moveProcess />}
		</>;
};
Page.getLayout = page => <DashboardLayout navpagetitle="Files" navfiltersitems={<>
				<ProcessFilter />
				<SearchButton />
				<NavItems />
				<ViewPreference />
			</>}>
		{page}
	</DashboardLayout>;
export default Page;